import {EAuthProfile} from 'store/slices/auth-slice/auth-slice-types';

export const getButtonNameByProfile = (profile: EAuthProfile) => {
    const defaultPrefix = 'Войти через';

    switch (profile) {
    case EAuthProfile.SAML: return `${defaultPrefix} ${profile.toUpperCase()}`;
    case EAuthProfile.KERBEROS: return 'Вход (сотрудники компании)';
    default: return `${defaultPrefix} ${profile}`;
    }
};

interface ICreateRequiredValidatorArgs {
    onResolve: () => void;
    onReject: () => void;
}
export const createRequiredValidator = ({onResolve, onReject}: ICreateRequiredValidatorArgs) => (() => ({
    validator(_: any, value: string) {
        if (!value) {
            onReject();
            return Promise.reject();
        }
        onResolve();
        return Promise.resolve();
    },
}));
